import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import CourseList from "./CourseList";
import { CourseWizard } from "./CreateCourseWizard";

const CoursesPage = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`} component={CourseWizard} />
            <Route path={`${path}/:courseId/wizard`} component={CourseWizard} />
            <Route path={`${path}/:courseId/:revId/wizard`} component={CourseWizard} />
            <Route default>
                <CourseList />
            </Route>
        </Switch>
    );
};

export default CoursesPage;
